import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useGetApiUsersMeQuery } from '../../../app/athenaApiGen';
import type { RootState } from '../../../app/store';

export const useMyProgramId = () => {
  const loggedIn = useSelector((state: RootState) => state.user.loggedIn);
  const profileFromStore = useSelector((state: RootState) => state.user.profile);

  // Profile is fetched on login (Dashboard.jsx). Only call users/me if profile isn't in Redux
  // (e.g. a cold refresh/race during boot).
  const shouldFetch = loggedIn && !profileFromStore;
  const { data, isLoading, isFetching, isError, error, refetch } =
    useGetApiUsersMeQuery(undefined, {
      skip: !shouldFetch,
    });

  const profile = profileFromStore ?? data;

  const programId = useMemo(() => {
    const roles = profile?.roles ?? [];
    const firstWithProgram = roles.find((r) => !!r?.programId);
    return firstWithProgram?.programId ?? '';
  }, [profile?.roles]);

  return {
    programId,
    profile,
    isLoading: (shouldFetch ? isLoading || isFetching : false),
    isError,
    error,
    refetch,
  };
};
